export default __webpack_public_path__ + "svg/calendar/2026/3/mayo.svg?878e3b4b";